import { StyledFlex } from "./styles";
import { FlexTypeProps } from "./types";

export const FlexDiv = ({
  children,
  direction,
  height,
  width,
  gap,
  justifycontent,
  alignitems,
  style,
}: FlexTypeProps) => {
  return (
    <StyledFlex
      direction={direction}
      height={height}
      width={width}
      gap={gap}
      justifycontent={justifycontent}
      alignitems={alignitems}
      style={style}
    >
      {children}
    </StyledFlex>
  );
};
